import { render, staticRenderFns } from "./ModalRecoverGroup.vue?vue&type=template&id=e1b4e842"
import script from "./ModalRecoverGroup.vue?vue&type=script&lang=js"
export * from "./ModalRecoverGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports